import React from 'react';
import LpaInformation from './lpa-information';
import { LpaType } from '../utils';
import {
  SuccessNotiPositionEnum,
  ShowSuccessNotificationType,
} from '../../../../commons';

interface HealthAndWelfareProps {
  userId: string;
  lpa: LpaType;
  setLpa: React.Dispatch<React.SetStateAction<LpaType>>;
  lpaFromData: LpaType;
  onSaveInLpa: (e: any, position: SuccessNotiPositionEnum) => void;
  showSuccessNotification: ShowSuccessNotificationType;
}

const HealthAndWelfare: React.FC<HealthAndWelfareProps> = ({
  userId,
  lpa,
  setLpa,
  lpaFromData,
  onSaveInLpa,
  showSuccessNotification,
}) => {
  const changeHealAndWelfareStatus = (value: string) => {
    setLpa(prev => ({
      ...prev,
      healthAndWelfareLPAStatus: value,
    }));
  };

  return (
    <div className="mt-10 govuk-bp:mt-14">
      <div className="govuk-form-group">
        <fieldset
          className="govuk-fieldset"
          aria-describedby="changedName-hint"
        >
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              Does this person have a Lasting power of attorney for health and
              welfare or court-appointed deputy (or equivalent)?
            </h1>
          </legend>
          <div className="govuk-radios" data-module="govuk-radios">
            <div className="govuk-radios__item">
              <input
                className="govuk-radios__input"
                id="is-allowed-yes"
                name="healthAndWelfareLPAStatus"
                type="radio"
                value="yes"
                checked={lpa.healthAndWelfareLPAStatus === 'yes'}
                onChange={() => changeHealAndWelfareStatus('yes')}
              />
              <label
                className="govuk-label govuk-radios__label"
                htmlFor="is-allowed-yes"
              >
                Yes
              </label>
            </div>
            <div className="govuk-radios__item">
              <input
                className="govuk-radios__input"
                id="is-allowed-no"
                name="healthAndWelfareLPAStatus"
                type="radio"
                value="no"
                checked={lpa.healthAndWelfareLPAStatus === 'no'}
                onChange={() => changeHealAndWelfareStatus('no')}
              />
              <label
                className="govuk-label govuk-radios__label"
                htmlFor="is-allowed-no"
              >
                No
              </label>
            </div>
          </div>
        </fieldset>
      </div>
      {lpa.healthAndWelfareLPAStatus === 'yes' && (
        <LpaInformation
          userId={userId}
          lpa={lpa}
          setLpa={setLpa}
          lpaFromData={lpaFromData}
          showSuccessNotification={showSuccessNotification}
          onSaveInLpa={onSaveInLpa}
        />
      )}
    </div>
  );
};

export default HealthAndWelfare;
